import "./baseConfig/font.css.ts.vanilla.mjs";
import "./textArea.css.ts.vanilla.mjs";
var r = "p273__textArea-db16_c5e36e7__1vfmaai0";
export {
  r as textAreaStyle
};
//# sourceMappingURL=textArea.mjs.map
